import React from 'react';
import { MarcomSpaceProps } from 'styled-system';
import { themeColor } from '@utils/styledTheme.util';
import { JoykitColor } from '@components/themes';
import styled from 'styled-components';
import { CloudImage } from '@components/CloudImage';
import { ECardsFrontVariant, getECardCopySrc, getECardSrc } from './ECard.variants';
import { DexecureImageOptions } from '@utils/cloudAssetUrl.util';

export const Shadow = styled(CloudImage)<{ color: JoykitColor }>`
  position: absolute;
  left: 0;
  top: 0;
  box-shadow: 0px 32px 64px ${({ color }) => themeColor(color)};
  border-radius: 70px;
  max-width: 100%;
  max-height: 100%;
`;

export const TextOverlayImage = styled(CloudImage)`
  position: absolute;
  left: 0;
  top: 0;
  max-width: 100%;
  max-height: 100%;
`;

const ECardWrapper = styled.div`
  position: relative;
  height: 100%;
`;

const StyledImage = styled(CloudImage)`
  position: relative;
  max-width: 100%;
  max-height: 100%;
`;

export interface ECardProps extends MarcomSpaceProps {
  variant: ECardsFrontVariant;
  isEagerLoading?: boolean;
  copyVariant: number;
  bgOptions?: DexecureImageOptions;
  cardType?: 'invite' | 'std';
}
type ShadowProps =
  | {
      hasShadow?: true;
      shadowColor: JoykitColor;
    }
  | {
      hasShadow: false;
      shadowColor?: never;
    };

export const ECard = React.forwardRef<HTMLDivElement, ECardProps & ShadowProps>(
  ({ variant, copyVariant, hasShadow = true, shadowColor, isEagerLoading, bgOptions = {}, cardType = 'invite', ...restProps }, ref) => {
    const bgSrc = getECardSrc(variant);
    const copySrc = getECardCopySrc(copyVariant, cardType);
    return (
      <ECardWrapper ref={ref} {...restProps}>
        {hasShadow && shadowColor && <Shadow className="ecard-shadow" src={bgSrc} color={shadowColor} alt="" {...bgOptions} />}
        <StyledImage
          mobileResizeWidth={600}
          className="ecard-theme"
          src={bgSrc}
          alt="Sample E-Card"
          isEagerLoading={isEagerLoading}
          width={cardType == 'invite' ? '' : '1060px'}
          height={cardType == 'invite' ? '' : '1500px'}
          {...bgOptions}
        />
        <TextOverlayImage className="ecard-copy" src={copySrc} alt="Sample E-Card Text" isEagerLoading={isEagerLoading} />
      </ECardWrapper>
    );
  }
);
